export default [
  {
    path:'/normi-test/page-1',
    name:'normi-test-page-1',
    meta:{
        title:"normi-test-page-1'",
        requiresAuth: false,
    },
    component:() => import(/* webpackChunkName: 'business-a-page-1' */ './normi-test-page-1/index.vue')
},

]